<template>
    <el-drawer :title="formData.id ? '管理优惠券' : '创建优惠券'" :visible.sync="visible" :wrapperClosable="false" size="auto"
        @closed="closed" append-to-body>
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-card header="基本信息">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="name" label="优惠券名称:">
                                <el-input v-model="formData.name" placeholder="请填写优惠券名称" size="medium" :maxlength="20">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
							<el-form-item prop="couponType" label="优惠券类型:">
							    <el-radio-group v-model="formData.couponType" @change="changeCouponType" :disabled="formData && formData.id ? true : false">
							        <el-radio :label="1" border>普通优惠券</el-radio>
							        <el-radio :label="2" border>特权购优惠券</el-radio>
							    </el-radio-group>
							</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="formData.couponType == 1">
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="couponPrice" label="优惠金额(元):">
                                <el-input-number style="width:100%" v-model="formData.couponPrice" :precision="2"
                                    controls-position="right" :min="0.00" :max="99999999.99" size="medium"
                                    placeholder="请填写优惠金额"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="couponSubtractPrice" label="满减金额(元):">
                                <el-input-number style="width:100%" v-model="formData.couponSubtractPrice" :precision="2"
                                    controls-position="right" :min="0.00" :max="99999999.99" size="medium"
                                    placeholder="请填写满减金额"></el-input-number>
                                <small class="from-tip"><span class="el-icon-warning"></span>订单中票品金额达到满减金额后才可使用，<em
                                        class="color-danger">满减金额必须大于优惠金额至少2.00元</em></small>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
						<el-col :xs="24" :sm="12">
						    <el-form-item prop="time" label="有效期:">
						        <el-date-picker v-model="formData.time" type="datetimerange" start-placeholder="开始时间"
						            end-placeholder="结束时间" class="fl" size="medium" :default-time="['00:00:00', '23:59:59']"
						            value-format="yyyy-MM-dd HH:mm:ss" unlink-panels>
						        </el-date-picker>
						    </el-form-item>
						</el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="useTerminal" label="使用终端:">
                                <el-radio-group v-model="formData.useTerminal">
                                    <el-radio :label="0" border>全平台</el-radio>
                                    <el-radio :label="3" border>APP</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="category" label="业务范围:">
                                <el-checkbox-group v-model="formData.category">
                                    <el-checkbox :label="1" border>演出</el-checkbox>
                                    <!-- <el-checkbox :label="2" border>众筹</el-checkbox> -->
                                    <el-checkbox :label="3" border  v-if="formData.couponType == 1">周边</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
						<el-col :xs="24" :sm="12" v-if="formData.couponType == 1">
						    <el-form-item prop="hideStatus" label="是否在列表显示:">
						        <el-radio-group v-model="formData.hideStatus">
						            <el-radio :label="0" border>显示</el-radio>
						            <el-radio :label="1" border>不显示</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="formData.couponType == 1">                        
                        <el-col v-if="formData.category.find(v => v === 1)" :xs="24" :sm="12">
                            <el-form-item prop="showTypeTags" label="可用活动类型:">
                                <el-cascader v-model="formData.showTypeTags" collapse-tags :options="showTypeTagList"
                                    :props="{multiple: true, value: 'id', label: 'name', children: 'tags', emitPath:false }" clearable placeholder="不限制活动类型"  style="width:100%" ref="cascader">
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item prop="stock" label="优惠券库存:" :rules="[{ required: true, message: '请填写优惠券库存' }, { validator: validateStock, trigger: 'change' }]">
                                <el-input-number style="width:100%" v-model="formData.stock" :precision="0" controls-position="right" :min="0" :max="99999" placeholder="请填写优惠券库存"></el-input-number>
                                <small class="from-tip">
                                    <span class="el-icon-warning"></span>
                                    输入整数，范围【0, 99999】，<em class="color-danger">0为不限制</em>
                                    <template v-if="formData.id && receivedCount > 0">
                                        当前已领取 <em class="color-danger">{{ receivedCount }}</em> 张，库存不可小于已领取数量
                                    </template>
                                </small>
                            </el-form-item>
                        </el-col>                       
                    </el-row>
                    <el-form-item v-if="formData.category.find(v => v === 1)" label="演出限制:">
                        <span slot="label">演出限制：
							<small class="from-tip" v-if="formData.couponType == 1"><span class="el-icon-warning"></span>  填写演出ID，多个ID之间用逗号分隔，不填视为所有演出通用</small>
							<small class="from-tip" v-if="formData.couponType == 2"><span class="el-icon-warning"></span>  特权购优惠券演出不能为空且只能选择一个票品</small>
						</span>
                        <el-input placeholder="输入需要限制使用的演出ID" v-model="sActivityIds">
                            <el-button slot="append" icon="el-icon-search" @click="searchActivity()">添加演出</el-button>
                        </el-input>
                        <el-table class="MT10 sortable-table" :data="sActivityList" size="mini" border stripe v-loading="sActivityLoading" row-key="id">
                            <el-table-column label="排序" width="48" class-name="sort-handle">
                                <span class="el-icon-sort"></span>
                            </el-table-column>
                            <el-table-column prop="id" label="演出ID" width="90"></el-table-column>
                            <el-table-column prop="name" label="演出名称" show-overflow-tooltip></el-table-column>
                            <el-table-column label="限制票品">
                                <template slot-scope="scope">
                                    <!-- 特权购：单选 -->
                                    <el-select v-if="formData.couponType == 2" v-model="scope.row.ids" placeholder="请选择票品" clearable>
                                        <el-option-group v-for="g in scope.row.sessions" :key="g.id" :label="g.name">
                                            <el-option v-for="item in g.tickets" :key="item.id"
                                                :label="g.name + ' - ' + item.name" :value="item.id">
                                                {{item.name}}
                                            </el-option>
                                        </el-option-group>
                                    </el-select>
                                    <!-- 普通优惠券：多选 -->
                                    <el-select v-else v-model="scope.row.ids" placeholder="所有票品可用" multiple clearable>
                                        <el-option-group v-for="g in scope.row.sessions" :key="g.id" :label="g.name">
                                            <el-option v-for="item in g.tickets" :key="item.id"
                                                :label="`${g.name} - ${item.name}`" :value="item.id">
                                                {{item.name}}
                                            </el-option>
                                        </el-option-group>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>

                    <!-- <el-form-item v-if="formData.category.find(v => v === 1)" prop="activityIds" label="演出限制:">
                        <el-input type="textarea" v-model="formData.activityIds" placeholder="请填写演出ID" size="medium"
                            :maxlength="200"></el-input>
                        <small class="from-tip"><span class="el-icon-warning"></span>填写演出ID，多个ID之间用逗号分隔</small>
                    </el-form-item> -->
                    <el-form-item v-if="formData.category.find(v => v === 2)" prop="raiseIds" label="众筹限制:">
                        <el-input type="textarea" v-model="formData.raiseIds" placeholder="请填写众筹ID" size="medium"
                            :maxlength="200"></el-input>
                        <small class="from-tip"><span class="el-icon-warning"></span>填写众筹ID，多个ID之间用逗号分隔</small>
                    </el-form-item>

                    <template v-if="formData.category.find(v => v === 3)">
                        
                        <el-form-item prop="goodsIds" label="周边限制:">
                            <el-input type="textarea" v-model="formData.goodsIds" placeholder="请填写周边ID" size="medium"
                                :maxlength="200"></el-input>
                            <small class="from-tip"><span class="el-icon-warning"></span>填写周边ID，多个ID之间用逗号分隔</small>
                        </el-form-item>
                    </template>
                    <el-form-item prop="subsidyUser" label="优惠券承担方:"
                        :rules="[{ required: formData.sType, message: '请选择优惠券承担方' }]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-select v-model="formData.sType" size="medium">
                                    <el-option :value="0" label="秀动平台"></el-option>
                                    <el-option :value="1" label="秀动商家(B类用户)"  v-if="formData.couponType == 1"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12" v-if="formData.sType == 1" >
                                <el-select v-model="formData.subsidyUser" :filterable="true"
                                    :remote="true" :remote-method="remote" :loading="remoteLoading"
                                    placeholder="选择优惠券承担方" size="medium">
                                    <el-option v-for="item in remoteOptions" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-col>
							<el-col :span="12" v-if="formData.sType == 0 && departmentList && departmentList.length > 0" >								
								<el-select
								    v-model="formData.underwriterDep"
									class="fl fl-big-select" 
								    filterable 
								    :remote="true" :remote-method="getDepartment"
								    placeholder="选择优惠券承担方"								    	    
								    size="medium">
								    <el-option
								        v-for="item in departmentList"
								        :key="item.key"
								        :label="item.value"
								        :value="item.key">
								    </el-option>
								</el-select>
							</el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item prop="description" label="备注:">
                        <el-input type="textarea" v-model="formData.description" placeholder="请填写" size="medium"
                            :maxlength="100"></el-input>
                    </el-form-item>
                </el-card>
                <el-card class="MT20" v-if="formData.couponType == 1">
                    <div slot="header">
                        <span class="MR10">定向发放</span>
                        <el-switch v-model="formData.orientationSend" :active-value="1" :inactive-value="0"></el-switch>
                    </div>
                    <TargetedSend v-if="visible && formData.orientationSend == 1" :formData.sync="formData" :showTypeTagList="showTypeTagList" :sendsActivityList="sendsActivityList"></TargetedSend>
                </el-card>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="submitLoading">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>
import Sortable from "sortablejs";
import TargetedSend from './TargetedSend.vue';
export default {
    components: {
        TargetedSend,
    },
    data() {
        this.defaultFormData = {
            id: null,
            // 名称：必填，最多20个字符，如果为空，提示：【请填写名称】，如果超长，提示：【名称最多允许填写20个字符】
            name: null,
            // 有效期：必填，使用日期时间范围选择器
            time: null,
            // 优惠金额：必填，取值范围【0.00，99999999.99】，如果为空，提示：【请填写优惠金额】，如果格式错误，提示：【请填写合理的优惠金额】
            couponPrice: undefined,
            // 满减金额：选填，取值范围【0.00，99999999.99】，有默认值：【0.00】，如果格式错误，提示：【请填写合理的满减金额】，
            // 输入框下面的提示文案如图所示：【订单总金额达到满减金额后才可使用，如果无满减门槛，请填写：0】
            couponSubtractPrice: undefined,
            // 演出限制：选填，最多200个字符，仅允许填写数字或逗号，如果格式有误，提示：【请填写有效的演出ID】，
            // 如果超长，提示：【演出限制最多允许填写200个字符】，下面的提示文案如图所示：【填写演出ID，多个ID之间用逗号分隔】，
            // 注意：如果用户填写的是中文逗号，需要自动替换成英文逗号
            activityIds: null,
            // 使用范围：必填，单选，默认选中【全平台】
            useTerminal: 0,
            // 备注：选填，最多100个字符，如果超长，提示：【备注最多允许填写100个字符】
            description: null,
            //优惠券类型 1：演出 2：众筹 3：周边 4：演出+众筹 5：演出+周边 6：演出+众筹+周边 7：众筹+周边	
            category: [],
            //限制众筹ID，多个用逗号隔开	
            raiseIds: null,
            //限制周边ID，多个用逗号隔开	
            goodsIds: null,
            //补贴方ID,0为秀动平台，其他为B类用户ID	
            subsidyUser: 0,
            sType: 0,
            //是否在列表显示 0:显示 1:隐藏
            hideStatus: 0,
            //优惠券库存 整数，范围【0, 99999】，0为不限制，仅普通优惠券展示
            stock: 0,
            //票品id 多个用英文都好拼接
            ticketIds: "",
            //业务演出ids, 包含ticketIds的演出id	
            businessActivityIds: "",
			//remindStatus:0
            showTypeTags: [],

            orientationSend: 0, //1:定向发放， 0：非定向发放
            sendCityType: 0, //0:全国 1:指定城市
            sendCity: 0, //定向发放城市 
            sendLimit: 0, //定向发放限制 0:不限制 1:限制演出类型 2:限制演出id
            sendLimitIds: "", //定向发放限制的类型id或演出id
            sendStartTime: "",  //定向发放开始时间
            sendEndTime: "", //定向发放结束时间
            datetimerange: [], //定向发放时间
			underwriterDep:[],
			couponType:1,
			sendMode:1,
			sendExcludeActivity:0
        }
        this.category = {
            1: [1],
            2: [2],
            3: [3],
            4: [1, 2],
            5: [1, 3],
            6: [1, 2, 3],
            7: [2, 3]
        }

        // // 验证使用范围
        const validateLimitIds = (rule, value, callback) => {
            if (value && !/^[,，0-9]+$/.test(value)) {
                callback(new Error('请填写有效的ID'));
            } else {
                callback();
            }
        };

        // 验证优惠券库存：编辑时不可小于已被领取的数量（0 为不限制，不参与比较）
        const validateStock = (rule, value, callback) => {
            if (this.formData.id && value > 0 && value < this.receivedCount) {
                callback(new Error(`库存不可小于已被领取的数量${this.receivedCount}`));
            } else {
                callback();
            }
        };

        return {
            visible: false,
            //编辑时已被领取的优惠券数量（来自列表行 receivedCount）
            receivedCount: 0,
            //库存校验器需挂到实例，模板内联 rules 才可引用
            validateStock,
            formData: {
                ...this.defaultFormData
            },
            rules: {
                name: { required: true, message: "请填写优惠券名称", trigger: 'change' },
                time: { required: true, message: "请选择有效期", trigger: 'change' },
                couponPrice: [
                    { required: true, message: "请填写优惠金额", trigger: 'change' },
                    // { validator: validateCouponPrice, trigger: 'change'}
                ],
                couponSubtractPrice: [
                    { required: true, message: "请填写满减金额", trigger: 'change' },
                    // {validator: validateCouponSubtractPrice, trigger: 'change'}
                ],
                activityIds: { validator: validateLimitIds, trigger: 'change' },
                raiseIds: { validator: validateLimitIds, trigger: 'change' },
                goodsIds: { validator: validateLimitIds, trigger: 'change' },
                category: [{ required: true, message: "请选择优惠券适用的业务范围", trigger: 'change' },],
				datetimerange: [{ required: true, message: "请选择定向发放时间", trigger: 'change' },],
				
            },
            submitLoading: false,
            remoteLoading: false,
            remoteOptions: [],


            sActivityIds: "",
            sActivityLoading: false,
            sActivityList: [],
			
			sendsActivityList: [],

            showTypeTagList: [],
			departmentList:[]
        };
    },
	watch: {
	  'formData.couponType': {
	    immediate: true,
	    handler(newVal) {
	      // 如果 couponType 为 2，自动勾选“演出”(label 1)
	      if (newVal === 2) {
	        if (!this.formData.category.includes(1)) {
	          this.formData.category.push(1);
	        }
	      } else {
	        // 如果 couponType 不是 2，移除“演出”
	        // 注意：如果 newVal 是 undefined/null，也走这里
	        this.formData.category = this.formData.category.filter(item => item !== 1);
	      }
	    }
	  }
	},
    created() {
        this.getShowTypeTag()
		this.getDepartment()
    },
    methods: {
        //获取活动类型
        getShowTypeTag() {
            this.$request({
                url: "/styleTag/showType/all",
                method: "post",
                params: { isAll: 1 }
            }).then(res => {
                const { state, result } = res.data;
                if (state == 1) {
                    this.showTypeTagList = result || []
                }
            })
        },
		
        show(data) {
            // const {id = null, name = null, beginTime, endTime, couponPrice = null, couponSubtractPrice = null, limitIds = null, useTerminal = 0, description = null} = data || {};
            const time = data && data.beginTime && data.endTime ? [data.beginTime, data.endTime] : null;
            

            //记录已被领取的数量，用于编辑时校验库存下限
            this.receivedCount = data && data.receivedCount ? data.receivedCount : 0;

            this.formData = {
                ...this.defaultFormData,
                ...data,
                time,
                //优惠券库存兜底：旧数据接口未返回 stock 时补 0（不限制）
                stock: data && data.stock != null ? Number(data.stock) : 0,
                category: data && data.category ? this.category[data.category] : [],
                sType: data && data.subsidyUser && data.subsidyUserType ? 1 : 0,
                subsidyUser: data && data.subsidyUser && data.subsidyUserType ? data.subsidyUser : null,
                showTypeTags: data && data.showTypeTags ? data.showTypeTags.split(',') : [],
				underwriterDep:data && data.underwriterDep ? data.underwriterDep.toString() : []
                // sendCityType: data && data.sendCity == 0 ? 0 : 1,                                         
            }
            if (this.formData.subsidyUser && this.formData.subsidyUserType && this.formData.subsidyUserName) {
                this.remoteOptions = [{ label: `[${this.$userType.get(this.formData.subsidyUserType)}]${this.formData.subsidyUserName}`, value: this.formData.subsidyUser }];
            }

            if( data ){
                let _sActivityIds = [];
                // if (data.activityIds) {
                //     _sActivityIds = data.activityIds.split(',');
                // }
                if (data.businessActivityIds) {
                    const _ids = data.businessActivityIds.split(',');
                    _sActivityIds = _sActivityIds.concat(_ids);
                }
                this.sActivityIds = _sActivityIds.toString();
                if (this.sActivityIds) {
                    this.searchActivity(() => {
                        this.$nextTick(() => {
                            const _ticketIds = (this.formData.ticketIds || '').split(',').filter(t => t !== '') || [];
                            const isSingle = this.formData.couponType == 2;
                            this.sActivityList.forEach((item, idx) => {
                                (item.sessions || []).forEach(s => {
                                    _ticketIds.forEach(t => {
                                        const foundTicket = s.tickets && s.tickets.find(t1 => t1.id == t);
                                        if (foundTicket) {
                                            if (isSingle) {
                                                // 特权购：单选模式，ids 为标量（用真实 ticket.id 数字保证与 el-option :value 严格相等）
                                                this.$set(this.sActivityList[idx], 'ids', foundTicket.id);
                                            } else {
                                                // 普通优惠券：多选模式，ids 为数组
                                                if (this.sActivityList[idx].ids) {
                                                    this.sActivityList[idx].ids.push(foundTicket.id);
                                                } else {
                                                    this.$set(this.sActivityList[idx], 'ids', [foundTicket.id]);
                                                }
                                            }
                                        }
                                    })
                                })
                            })
                        })
                    });
                }
                if( data.sendLimit == 1 ){
                    this.formData.sendLimitIds = data.sendLimitIds?.split(',') || []
                }
				if( data.sendLimit == 3 ){
				    this.formData.sendLimitIds = parseInt(data.sendLimitIds) || ''
				}
				
            }

            this.visible = true;
        },
        closed() {
            this.formData = { ...this.defaultFormData };
            this.receivedCount = 0;
            this.remoteOptions = [];
            this.sActivityList = [];
			this.sendsActivityList = [];
            this.sActivityIds = "";
            this.$nextTick(() => {
                this.$refs['formData'].clearValidate();
            });
        },
		changeCouponType(){
			this.sActivityList = [];
			this.sendsActivityList = [];
			this.sActivityIds = "";
		},
		// 搜索承担部门
		async getDepartment(query) {				
			if (query !== "") {					
				this.$request({
					url: "/common/underwriterDep",
					method: "post",						
				}).then(res => {
					const { state, result } = res.data;
					if (state == 1) {
						this.departmentList = result || []
					}
				})
			}
		},
        async remote(q) {
            if (!q) {
                this.remoteOptions = [];
                return;
            }

            this.remoteLoading = true;

            const res = await this.$request({
                url: '/userInfo/query',
                method: 'post',
                data: { queryCount: 20, queryValue: q, userType: -1 }
            }).catch(() => {
                return { data: { state: '0', msg: '请求错误' } };
            }).finally(() => {
                this.remoteLoading = false;
            });

            const { state, msg, result } = res.data;

            if (state !== '1') {
                this.$message.error(msg || '请求失败');
                return;
            }

            this.remoteOptions = (result || []).map(item => {
                const { userType, id, name } = item;
                return { label: `[${this.$userType.get(userType)}]${name}`, value: id };
            });
        },

        //搜索演出
        async searchActivity(callback) {
			
            if (this.sActivityIds) {
				const ids = this.sActivityIds.trim().replace(/，/g, ',').split(',').map(s => s.trim()).filter(s => s !== '');			
				if( ids && ids.length > 1 && this.formData.couponType == 2 ){
					return this.$message.error('特权购优惠券只能选择一个演出！');					
				}
                this.sActivityLoading = true;

                this.sActivityIds = this.sActivityIds.replace(/，/g, ',');

                let _sActivityIds = this.sActivityIds.split(',');
                _sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));

                const res = await this.$request({
                    url: '/activity/activityIdNameList',
                    method: 'post',
                    data: _sActivityIds
                }).catch(() => {
                    return { data: { state: '0', msg: '请求错误' } };
                }).finally(() => {
                    this.sActivityLoading = false;
                });

                const { state, msg, result } = res.data;

                if (state != 1) {
                    return this.$message.error(msg || '请求失败');

                } else {
                    if (result && result.length > 0) {
                        console.log('[CouponManage][searchActivity] 接口返回:', JSON.parse(JSON.stringify(result)));

                        result.map(item => {
                            if (!this.sActivityList.find(v => v.id == item.id)) {
                                this.sActivityList.push(item)
                            }
                        })
                        console.log('[CouponManage][searchActivity] sActivityList:', JSON.parse(JSON.stringify(this.sActivityList)));
                        this.drag();
                        callback && callback();

                    } else {
                        this.$message.error(msg || '没有找到相关演出');
                    }
                }
            }
        },
        //删除演出
        delActivity(id) {
            this.sActivityList = this.sActivityList.filter(v => v.id != id);
        },

        //拖拽排序
        drag(){
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                Sortable.create(el, {
                    disabled: false, // 拖拽不可用? false 启用
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    handle: ".sort-handle",
                    onEnd: (e) => { // 拖拽结束时的触发
                        let arr = JSON.parse(JSON.stringify(this.sActivityList)); // 获取表数据
                        arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                        this.$nextTick(() => {
                            this.sActivityList = [...arr];
                        })
                    },
                });
            })
        },

        // 表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (!valid) {
                    return;
                }
                const { formData: { time, couponPrice, couponSubtractPrice, goodsIds, raiseIds, category, subsidyUser, sType } } = this;

                if (parseFloat(couponSubtractPrice) - parseFloat(couponPrice) < 2 &&  this.formData.couponType == 1 ) {
                    return this.$message.error('请填写合理的满减金额');
                }
                const [beginTime, endTime] = time || [];

                let _category = null
                const new_category = (category.sort()).toString()
                for (const key in this.category) {
                    if (this.category[key].toString() == new_category) {
                        _category = key
                    }
                }

                let _activityIds = [];
                let _businessActivityIds = [];
                let _ticketIds = [];
                this.sActivityList.map(item => {
                    const idsIsArray = Array.isArray(item.ids);
                    if(!item.ids || (idsIsArray && item.ids.length < 1)){
                        _activityIds.push(item.id);
                    }else{
                        // _businessActivityIds.push(item.id);
                        _ticketIds = idsIsArray ? _ticketIds.concat(item.ids) : _ticketIds.concat([item.ids]);
                    }
                    _businessActivityIds.push(item.id);
                })

                if( _ticketIds.length > 30 ){
                    return this.$message.error('限制票品不能超过30个');
                }
				if( this.formData.couponType == 2 && _businessActivityIds =='' ){
					return this.$message.error('特权购优惠券演出不能为空');
				}
				if( this.formData.couponType == 2 && _ticketIds.length == 0 ){
					return this.$message.error('特权购优惠券限制票品不能为空！');
				}
				if( this.formData.couponType == 2 && _businessActivityIds.length > 1 ){
					return this.$message.error('特权购优惠券不能选择多个演出！');
				}
				
				
				//定向发放限制演出，场次
				const _sendLimitTpIds = [];
				const _sendLimitBusinessActivityIds = [];
				const _sendLimitIds = [];
				
				if( this.sendsActivityList && this.sendsActivityList.length > 0 ){
					this.sendsActivityList.forEach(item => {
					      const { id, ids } = item;				      
					      
					      if (ids && ids.length > 0) {
					        
					        _sendLimitTpIds.push(...ids);  
					        
					      } else {
					       
					        _sendLimitIds.push(id);
					      }
						  _sendLimitBusinessActivityIds.push(id);
					    });
				}
				
                let _formData = {...this.formData}
                let _sendConfig = {
                    sendCity: "", //定向发放城市 
                    sendLimit: "", //定向发放限制 0:不限制 1:限制演出类型 2:限制演出id
                    sendLimitIds: "", //定向发放限制的类型id或演出id
					sendLimitBusinessActivityIds:"",
					sendLimitTpIds:"",
                    sendStartTime: "",  //定向发放开始时间
                    sendEndTime: "", //定向发放结束时间
                }
                if( _formData.orientationSend == 1 ){
                    _sendConfig = {
                        sendCity: _formData.sendCityType == 0 ? 0 : _formData.sendCity.toString(),
                        sendStartTime: _formData.datetimerange[0],
                        sendEndTime: _formData.datetimerange[1],
						sendLimitTpIds:_formData.sendLimit == 2 ? _sendLimitTpIds.toString() : '',
						sendLimitBusinessActivityIds:_formData.sendLimit == 2 ? _sendLimitBusinessActivityIds.toString() : '',
						sendLimitIds:  _formData.sendLimit == 2 ? _sendLimitIds.toString() : _formData.sendLimit == 1 || _formData.sendLimit ==  3 ? _formData.sendLimitIds.toString() : ''
                    }
                }
                _formData = {
                    ..._formData,
                    ..._sendConfig
                }
				
				
				this.$request({
				    url: "/coupon/validate2",
				    method: 'post',
				    data: {
						..._formData,
						beginTime,
						endTime,
						activityIds: _activityIds.toString(),
						goodsIds: goodsIds && goodsIds.replace(/，/g, ','),
						raiseIds: raiseIds && raiseIds.replace(/，/g, ','),
						category: _category,
						subsidyUser: sType === 0 ? 0 : (subsidyUser || 0),
						businessActivityIds: _businessActivityIds.toString(),
						ticketIds: _ticketIds.toString(),
                        showTypeTags: this.formData.showTypeTags.toString(),
						underwriterDep:this.formData.underwriterDep && this.formData.underwriterDep.length > 0 ? this.formData.underwriterDep.toString() : null,
					}
				}).then((res) => {
				    //处理成功回调
				    const { state, msg, result } = res.data;
				    if (state && state == 1 && result) {
				        if( result.checkResult1 != 0 || result.checkResult2 != 0 ){
							var _msg1 = result.checkResult1 > 0 ? `<div class="color-danger">当前优惠券设置了B类用户承担，但是未填写限制使用的演出ID或周边ID</div>` : ''
							var _msg2 = result.checkResult2 > 0 ? '<div class="color-danger">当前优惠券限制使用的演出或者周边所对应的结款方跟承担方不一致</div>' : ''
							this.$confirm(
								`注意：<br>${_msg1}${_msg2}这可能导致结算时扣款出现偏差，是否继续？`,
								'提交', {
									// type: 'success',
									// center: true,
									confirmButtonText: '继续提交',
									cancelButtonText: '取消',
									closeOnClickModal: false,
									dangerouslyUseHTMLString: true,
								}).then(() => {
								
								this.saveCoupon({
								    ..._formData,
								    beginTime,
								    endTime,
								    activityIds: _activityIds.toString(),
								    goodsIds: goodsIds && goodsIds.replace(/，/g, ','),
								    raiseIds: raiseIds && raiseIds.replace(/，/g, ','),
								    category: _category,
								    subsidyUser: sType === 0 ? 0 : (subsidyUser || 0),
								    businessActivityIds: _businessActivityIds.toString(),
								    ticketIds: _ticketIds.toString(),
                                    showTypeTags: this.formData.showTypeTags.toString(),
									underwriterDep:this.formData.underwriterDep && this.formData.underwriterDep.length > 0 ? this.formData.underwriterDep.toString() : null,
									
								});
							}).catch(() => {
							
							})
						}else{
							this.saveCoupon({
							    ..._formData,
							    beginTime,
							    endTime,
							    activityIds: _activityIds.toString(),
							    goodsIds: goodsIds && goodsIds.replace(/，/g, ','),
							    raiseIds: raiseIds && raiseIds.replace(/，/g, ','),
							    category: _category,
							    subsidyUser: sType === 0 ? 0 : (subsidyUser || 0),
							    businessActivityIds: _businessActivityIds.toString(),
							    ticketIds: _ticketIds.toString(),
                                showTypeTags: this.formData.showTypeTags.toString(),
								underwriterDep:this.formData.underwriterDep && this.formData.underwriterDep.length > 0 ? this.formData.underwriterDep.toString() : null,
								
							});
						}
				    } else {
				        return this.$message.error(msg || "操作失败");
				    }
				}).finally(() => {
				    
				});
                
            });
        },

        // 保存
        async saveCoupon(formData) {
            const flag = !formData.id ? 'confirm' : await this.$confirm('修改后的优惠券内容只会对后续新发放领取的优惠券生效<div class="color-danger">对于已经发放出去的优惠券不受影响</div>', '提示', {
                confirmButtonText: '确认更新',
                cancelButtonText: '取消',
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                center: true,
                dangerouslyUseHTMLString: true
            }).catch(() => 'cancel');

            if (flag === 'cancel') {
                return;
            }

            this.submitLoading = true;

            const res = await this.$request({
                url: '/coupon/save',
                method: 'post',
                data: { ...formData }
            }).catch(() => {
                return { data: { state: '0', msg: '请求错误' } };
            }).finally(() => {
                this.submitLoading = false;
            });

            const { state, msg } = res.data;

            if (state !== '1') {
                this.$message.error(msg || '请求失败');
                return;
            }

            this.$emit('submitSuccess');
            this.visible = false;
        }
    }
};
</script>